import React, { useEffect, useState } from 'react';
import { Truck } from 'lucide-react';
import { MOCK_ORDERS } from '../../../../mocks/Orders.mocks';
import { Order } from '../../../../types/Order.types';
import { ModuleHeader } from '../../../../components/shared/ModuleHeader/ModuleHeader';
import { ShipmentTrackingModal } from './components/ShipmentTrackingModal/ShipmentTrackingModal';
import './DistributionView.css';

export const DistributionView = ({ onSelectShipment }: {
  onSelectShipment?: (order: Order) => void,
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const [selectedShipment, setSelectedShipment] = useState<Order | null>(null);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleSelectShipment = (order: Order) => {
    setSelectedShipment(order);
    if (onSelectShipment) {
      onSelectShipment(order);
    }
  };

  return (
    <div className="distribution-view">
      <ModuleHeader title="Distribution_Network" subtitle="Seguimiento de envíos activos y red de librerías asociadas." />

      <div className="distribution-grid">
        <div className="distribution-panel">
          <h3 className="distribution-panel-title">Envíos_En_Tránsito</h3>
          <div className="shipments-list">
            {MOCK_ORDERS.filter(o => o.status === 'shipped' || o.status === 'processing').map((order) => (
              <div
                key={order.id}
                className="shipment-card"
                onClick={() => handleSelectShipment(order)}
              >
                <div className="shipment-header">
                  <span className="shipment-id">{order.id}</span>
                  <span className="shipment-status">{order.status}</span>
                </div>
                <div className="shipment-destination">
                  <Truck size={12} />
                  <span>Destino: {order.customer}</span>
                </div>
                <div className="progress-track">
                  <div
                    className="progress-bar"
                    style={{ width: isMounted ? (order.status === 'shipped' ? '75%' : '25%') : '0%' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="distribution-panel">
          <h3 className="distribution-panel-title">Puntos_De_Venta_Activos</h3>
          <div className="stores-list">
            {['Librería El Ateneo', 'Amazon ES', 'Casa del Libro', 'Librería Gandhi', 'Fnac España'].map((store) => (
              <div key={store} className="store-item">
                <span className="store-name">{store}</span>
                <div className="store-status-container">
                  <div className="store-status-indicator" />
                  <span className="store-status-text">Online</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedShipment && (
        <ShipmentTrackingModal order={selectedShipment} onClose={() => setSelectedShipment(null)} />
      )}
    </div>
  );
};
